import {Component} from '@angular/core';

@Component({
  selector: 'app-arrow-right-icon',
  styles: `
    :host {
      height: 15px;
      width: 18px;
      display: inline-block;
      line-height: 0;
    }
  `,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17" fill="none">
      <path d="M11.5 1L19 8.5M19 8.5L11.5 16M19 8.5H1" stroke="#5C0A31" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round"/>
    </svg>
  `,
  standalone: true
})

export class ArrowRightIconComponent {

}
